module.exports = __webpack_public_path__ + "img/team-18.d4d66e6d.jpg";